import { Modal as CosmaModal } from 'is24-corecss';
import { Modal as Root } from './Modal';
import { Header } from './Header';
import { Footer } from './Footer';
import { Content } from './Content';
import { Title } from './components/Title';
import { Description } from './components/Description';
import { BannerImage } from './components/BannerImage';
import { Benefits } from './components/Benefits';
import { Tab, Tabs } from './components/Tabs';

export const Modal = {
  V3: Object.assign(Root, {
    Header,
    Footer,
    Content,
    Title,
    Description,
    BannerImage,
    Benefits,
    Tabs,
    Tab,
    CloseButton: CosmaModal.CloseButton,
  }),
};
